import { z } from 'zod';
import { DEPARTMENT_CONSTRAINTS } from './constraints.js';
export const updateDepartmentInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${DEPARTMENT_CONSTRAINTS.name.label} cannot be empty.`)
        .max(DEPARTMENT_CONSTRAINTS.name.maxLength)
        .optional(),
});
//# sourceMappingURL=update-input.js.map